export default __webpack_public_path__ + "static/media/f0021-02.6802a69f.png";